<template>
  <div>
    <v-dialog v-model="dialog" persistent width="640">
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left color="primary">mdi-printer</v-icon>
          Print Documents
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="pb-0">
          Invoice # {{ item.invoice_code || item.id }}
          <span v-if="item.customer">
            &mdash; {{ item.customer.customer_name }}</span
          >
        </v-card-subtitle>
        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="6" sm="4">
              <confirm-invoice-print-modal :item="item">
                <template #activator="{ open }">
                  <v-card
                    outlined
                    hover
                    class="print-tile text-center pa-4"
                    @click="open"
                  >
                    <v-icon size="36" color="primary">mdi-printer</v-icon>
                    <div class="subtitle-2 mt-2">Sales Invoice</div>
                    <div class="caption grey--text">Dot-matrix receipt</div>
                  </v-card>
                </template>
              </confirm-invoice-print-modal>
            </v-col>
            <v-col
              v-for="option in printOptions"
              :key="option.label"
              cols="6"
              sm="4"
            >
              <v-card
                outlined
                hover
                class="print-tile text-center pa-4"
                @click="option.handler(item)"
              >
                <v-icon size="36" :color="option.color">{{
                  option.icon
                }}</v-icon>
                <div class="subtitle-2 mt-2">{{ option.label }}</div>
                <div class="caption grey--text">{{ option.description }}</div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')"> Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text mb-0">printModalCard.vue</p>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex/dist/vuex.common.js";
import confirmInvoicePrintModal from "../Payment/confirmInvoicePrintModal.vue";
export default {
  components: { confirmInvoicePrintModal },
  props: ["item"],
  data() {
    return {
      dialog: true,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      default_server_url: "auth/default_server_url",
    }),
    printOptions() {
      return [
        {
          label: "Delivery Receipt",
          description: "With serial numbers",
          icon: "mdi-truck-delivery",
          color: "green",
          handler: this.print_delivery_receipt,
        },
        {
          label: "Warranty Certificate",
          description: "Warranty terms slip",
          icon: "mdi-shield-check",
          color: "orange",
          handler: this.print_warranty_certificate,
        },
        {
          label: "Statement of Account",
          description: "Customer balance summary",
          icon: "mdi-list-box",
          color: "indigo",
          handler: this.print_statement_of_account,
        },
        {
          label: "Journal Entries",
          description: "Invoice journal entries",
          icon: "mdi-book-open-variant",
          color: "deep-purple",
          handler: this.print_invoice_journal,
        },
      ];
    },
  },
  methods: {
    print_warranty_certificate(item) {
      const { generateWarrantyReceipt } = require("@/utils/dotMatrixPrinter");

      // Determine print type and warranty terms from the assigned warranty policy
      let printType = "mixed";
      let warrantyType = "regular";
      let remarks = item.purpose || "";

      if (item.warranty_policy && item.warranty_policy.warranty_type) {
        const type = item.warranty_policy.warranty_type;
        if (
          ["desktop", "laptop", "cctv", "repairs", "printer"].includes(type)
        ) {
          printType = type;
          warrantyType = type;
          remarks = this.get_remarks_for_type(type);
        }
      }

      const printer = generateWarrantyReceipt(
        item,
        printType,
        remarks,
        warrantyType
      );
      printer.print();
    },
    get_remarks_for_type(type) {
      const remarksMap = {
        desktop:
          "Desktop PC Set: Major Parts (6 Months), Minor Parts (3 Months), Service (1 Year).",
        laptop:
          "Laptop: 7-Day Outright Replacement, 1-Year Warehouse Warranty.",
        cctv: "CCTV System: 1-Year Parts Replacement, 1-Month Service.",
        repairs:
          "Repairs & Replacements: Warranty applies only to the specific part replaced.",
        printer:
          "Printer Warranty: 3months JMB Service Warranty, 2years Brand Service Warranty.",
      };
      return remarksMap[type] || "";
    },
    print_invoice_journal(item) {
      let url = this.default_server_url + "/print_invoice_journal/" + item.id;
      window.open(url);
    },
    print_delivery_receipt(item) {
      const { generateDeliveryReceipt } = require("@/utils/dotMatrixPrinter");
      const printer = generateDeliveryReceipt(item);
      printer.print();
    },
    async print_statement_of_account(item) {
      if (!item.customer) {
        this.$alert({
          title: "Validation",
          message: "No customer associated with this invoice.",
          color: "warning",
          icon: "mdi-alert",
        });
        return;
      }
      let x = await this.$confirm({
        title: "Print Statement",
        message: "Are you sure you want to proceed with your request?",
        color: "primary",
        icon: "mdi-printer",
      });
      if (x) {
        let url =
          this.default_server_url +
          "/print_statement_of_account/" +
          item.customer.id;
        window.open(url);
      }
    },
    submit() {
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
.print-tile {
  cursor: pointer;
  height: 100%;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: var(--v-primary-base);
  }
}
</style>
